<div class="media-test-container">
  <h1>Medie Upload & Visning Test</h1>

  <!-- Error Message -->
  @if (errorMessage) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
  }

  <!-- Success Message -->
  @if (successMessage) {
  <div class="success-message-global">
    {{ successMessage }}
  </div>
  }

  <!-- Upload Section -->
  <section class="upload-section">
    <h2>📤 Upload Fil</h2>
    <div class="upload-area">
      <input
        type="file"
        id="file-input"
        (change)="onFileSelected($event)"
        [disabled]="isUploading"
      />

      @if (selectedFile) {
      <div class="file-info">
        <p><strong>Valgt:</strong> {{ selectedFile.name }}</p>
        <p><strong>Størrelse:</strong> {{ getFileSize(selectedFile.size) }}</p>
        <p><strong>Type:</strong> {{ selectedFile.type }}</p>
      </div>
      }

      <button
        class="btn-primary"
        (click)="uploadFile()"
        [disabled]="!selectedFile || isUploading"
      >
        {{ isUploading ? "Uploader..." : "Upload Fil" }}
      </button>

      @if (isUploading) {
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="uploadProgress"></div>
        <span class="progress-text">{{ uploadProgress }}%</span>
      </div>
      } @if (uploadStatusMessage) {
      <div class="status-message">
        <p>{{ uploadStatusMessage }}</p>
      </div>
      } @if (uploadedObfuscatedName) {
      <div class="uploaded-file-info">
        <p class="success-text">✅ Upload succesfuldt!</p>
        <div class="obfuscated-name-section">
          <label>Obfuskeret filnavn:</label>
          <div class="obfuscated-name-box">
            <code>{{ uploadedObfuscatedName }}</code>
            <button
              class="btn-copy"
              (click)="copyToClipboard(uploadedObfuscatedName)"
              title="Kopiér til udklipsholder"
            >
              📋 Kopiér
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </section>

  <!-- View Section -->
  <section class="view-section">
    <h2>👁️ Vis Medie</h2>
    <div class="view-area">
      <div class="input-group">
        <label for="obfuscated-input">Obfuskeret Filnavn:</label>
        <input
          type="text"
          id="obfuscated-input"
          [(ngModel)]="obfuscatedFilename"
          placeholder="Indtast obfuskeret filnavn"
          [disabled]="isLoading"
        />
        <button
          class="btn-primary"
          (click)="loadMedia()"
          [disabled]="!obfuscatedFilename.trim() || isLoading"
        >
          {{ isLoading ? "Indlæser..." : "Indlæs Medie" }}
        </button>
      </div>

      @if (isLoading && downloadProgress > 0) {
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="downloadProgress"></div>
        <span class="progress-text"
          >Downloader chunks: {{ downloadProgress }}%</span
        >
      </div>
      }

      <!-- Media Metadata -->
      @if (mediaMetadata) {
      <div class="metadata">
        <h3>Fil Information</h3>
        <ul>
          <li><strong>Navn:</strong> {{ mediaMetadata.original_name }}</li>
          <li><strong>Type:</strong> {{ mediaMetadata.mime_type }}</li>
          <li>
            <strong>Størrelse:</strong>
            {{ getFileSize(mediaMetadata.file_size) }}
          </li>
          <li><strong>Chunks:</strong> {{ mediaMetadata.chunk_count }}</li>
        </ul>
      </div>
      }

      <!-- Media Display -->
      @if (mediaType) {
      <div class="media-display">
        <!-- Image Display -->
        @if (mediaType === 'image') {
        <div class="image-container">
          <img [src]="mediaUrl" alt="Uploadet billede" />
        </div>
        }
        <!-- Video Display -->
        @if (mediaType === 'video') {
        <div class="video-container">
          @if (isLoading) {
          <p class="loading-message">Buffer video... {{ downloadProgress }}%</p>
          }
          <video controls preload="auto"></video>
        </div>
        }
        <!-- Other Files -->
        @if (mediaType === 'other') {
        <div class="other-file">
          <p>✅ Fil downloadet succesfuldt</p>
        </div>
        }
      </div>
      }
    </div>
  </section>
</div>
